import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["preview", "copyButton"]

  updatePreview(event) {
    const anchorValue = event.target.value.trim()
    
    if (anchorValue) {
      this.previewTarget.textContent = anchorValue
      this.copyButtonTarget.style.display = "block"
      
      // Update clipboard data attribute
      this.copyButtonTarget.setAttribute("data-clipboard-text", `[image:${anchorValue}]`)
    } else {
      this.previewTarget.textContent = "anchor-name"
      this.copyButtonTarget.style.display = "none"
    }
  }
}